const contact = {
  state : {
    show : false
  },
  mutations : {
    UPDATE_SHOW_STATUS (state,isShow){
      state.show = isShow;
    }
  },
  actions : {
    UPDATE_SHOW_STATUS({ commit },isShow){
      commit('UPDATE_SHOW_STATUS',isShow);
    }
  }
}

export default contact;



// WEBPACK FOOTER //
// ./src/store/modules/contact.js